import { createSelector } from "reselect";
import { selectionsSelector } from "../engine/engine.selectors";
import { IStore } from "../store";
import { TariffaSingola } from "../../types/TariffaSingola";
import { Configuratore, LineaEnum } from "../../types/Configuratore";
import { DiscountState } from "./discount.types";
import { intermediarioDataSelector } from "../intermediario/intermediario.selectors";
import { Intermediario } from "../../types/Intermediario";

export const discountSelector = (state: IStore) => state.discount;
export const calculatingSelector = (state: IStore) => state.discount.calculating;
export const semestraleSelector = (state: IStore) => state.discount.semestrale;

export const prezzoFinaleSelector = createSelector(selectionsSelector, discountSelector, (selections, discount) => {
  return discount.prezzo !== undefined ? discount.prezzo : selections.prezzo;
});
export const prezzoAnnuoSelector = (state: IStore) => state.discount.prezzoAnnuo;

export const getLineaFromSelections = (selections: Partial<TariffaSingola>) => {
  if (selections.dipendente && selections.vivere && selections.muoversi) {
    return LineaEnum.mobVivLav;
  } else if (!selections.dipendente && selections.vivere && selections.muoversi) {
    return LineaEnum.mobViv;
  } else if (!selections.dipendente && !selections.vivere && selections.muoversi) {
    return LineaEnum.mob;
  }
  return LineaEnum.mob;
};

export const preventivoSelector = createSelector(
  selectionsSelector,
  discountSelector,
  intermediarioDataSelector,
  (selections: Partial<TariffaSingola>, discount: DiscountState, intermediario?: Intermediario) => {
    if (selections.famiglia !== undefined && intermediario?.tokenIntermediario) {
      const preventivo: Configuratore = {
        olsFp: {
          lineaProdotto: getLineaFromSelections(selections),
          nucleoFamigliare: selections.famiglia,
        },
        frazionamento: discount.semestrale ? 2 : 1,
        codiceSconto: discount.voucher,
        tokenIntermediario: intermediario?.tokenIntermediario,
      };
      return preventivo;
    } else {
      return undefined;
    }
  },
);
